module.exports = __webpack_public_path__ + "img/banner_pic.7858b69e.webp";